import { RECEIVE_RESULTS } from '../actions/results';

export default function results(state=[], action) {
  switch(action.type) {
    case RECEIVE_RESULTS:
      if(action.append){
        const old_state = Object.assign({}, state);
        old_state.hits.push(...action.results.hits);
        return old_state;
      } else {
        return action.results
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/results.js